module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4TIH0"))).then(() => module.bundle.root('hEqeo'));